import { useAtom } from 'jotai';
import { useState } from 'react';

import { toast } from '@/lib/v2/components';

import { useAutomationService } from '@/src/infrastructure/Protocol/Automation/useAutomationService';
import { atomJourneyDetail } from '@/src/modules/AutomationModuleNew/atoms/flows';

export const useGetJourneyDetail = () => {
  const [journeyDetailIsLoading, setJourneyDetailIsLoading] = useState(false);
  const [journeyDetail, setJourneyDetail] = useAtom(atomJourneyDetail);
  const automationService = useAutomationService();

  const getJourneyDetail = async (journeyId: number) => {
    try {
      setJourneyDetailIsLoading(true);
      const response = await automationService.getJourneyDetail(journeyId);
      setJourneyDetailIsLoading(false);
      if (response.success) {
        setJourneyDetail(response.data);
      } else {
        toast({
          variant: 'error',
          title: 'Error',
          body: 'Journey detail not found',
        });
      }
    } catch (error) {
      setJourneyDetailIsLoading(false);
      console.error('Error fetching journey detail:', error);
      throw error;
    }
  };

  return { journeyDetailIsLoading, journeyDetail, getJourneyDetail };
};
